import {Routes} from '@src/Constant/routes';
import {RouteComponentProps} from '@reach/router';
import React from 'react';
import {KeyRouteMap} from '../types';

// Composants liés à l'écoute
const AppHomeListen = React.lazy(
  () => import('@src/App/components/pages/listen/AppHomeListen'),
);
const RadioHomePage = React.lazy(
  () => import('@src/App/components/pages/listen/Radio/RadioHomePage'),
);
const RadioCategoryPage = React.lazy(
  () => import('@src/App/components/pages/listen/Radio/RadioCategoryPage'),
);
const PodCastHomePage = React.lazy(
  () => import('@src/App/components/pages/listen/PodCast/PodCastHomePage'),
);
const PodCastCategoryPage = React.lazy(
  () => import('@src/App/components/pages/listen/PodCast/PodCastCategoryPage'),
);
const PodCastSinglePage = React.lazy(
  () => import('@src/App/components/pages/listen/PodCast/PodCastSinglePage'),
);
const ListenRedirection = React.lazy(
  () => import('@src/App/components/pages/listen/ListenRedirection'),
);

const emptyRoute = {
  component: React.lazy(() => {
    const EmptyComponent = () => React.createElement('div');
    return Promise.resolve({default: EmptyComponent});
  }),
};

export const listenRoutes: KeyRouteMap = {
  [Routes.HOME_LISTEN]: {component: AppHomeListen},
  [Routes.RADIO_HOME]: {
    component: RadioHomePage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.RADIO_CATEGORY]: {
    component: RadioCategoryPage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.RADIO_CATEGORY_HOME]: {
    component: RadioCategoryPage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.RADIO_PLAYER]: {
    ...emptyRoute,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.PODCAST_CATEGORY]: {
    component: PodCastCategoryPage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.PODCAST_CATEGORY_HOME]: {
    component: PodCastCategoryPage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.PODCAST_SINGLE]: {
    component: PodCastSinglePage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.PODCAST_HOME]: {
    component: PodCastHomePage,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.PODCAST_PLAYER]: {
    ...emptyRoute,
    parent: Routes.HOME_LISTEN,
  },
  [Routes.LISTEN_REDIRECTION]: {
    component: ListenRedirection,
    parent: Routes.HOME_LISTEN,
  },
};
